var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', {
    attrs: {
      "width": "300",
      "value": true
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "ma-3",
    staticStyle: {
      "right": "0"
    },
    attrs: {
      "absolute": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Options")]), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-5"
  }, [_c('canvas', {
    ref: "canvas",
    staticClass: "d-block mx-auto",
    staticStyle: {
      "width": "144px",
      "height": "144px"
    },
    attrs: {
      "width": "288",
      "height": "288"
    }
  }), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Scale to fit",
      "disabled": _vm.opts.w == _vm.opts.h
    },
    model: {
      value: _vm.opts.scale,
      callback: function ($$v) {
        _vm.$set(_vm.opts, "scale", $$v);
      },
      expression: "opts.scale"
    }
  }), _c('v-checkbox', {
    attrs: {
      "hide-details": "",
      "label": "Add border"
    },
    model: {
      value: _vm.opts.border,
      callback: function ($$v) {
        _vm.$set(_vm.opts, "border", $$v);
      },
      expression: "opts.border"
    }
  })], 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Cancel")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "disabled": _vm.loadImgStatus.pending,
      "loading": _vm.saveStatus.pending
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" Save ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }